export const TOURNAMENT_FORMATS = {
  SINGLE_ELIMINATION: 'single_elimination',
  DOUBLE_ELIMINATION: 'double_elimination',
  MODIFIED_SINGLE_ELIMINATION: 'modified_single_elimination',
  ROUND_ROBIN: 'round_robin'
};

export const TOURNAMENT_FORMAT_LABELS = {
  [TOURNAMENT_FORMATS.SINGLE_ELIMINATION]: 'Single Elimination',
  [TOURNAMENT_FORMATS.DOUBLE_ELIMINATION]: 'Double Elimination',
  [TOURNAMENT_FORMATS.MODIFIED_SINGLE_ELIMINATION]: 'Modified Single Elimination (APA)',
  [TOURNAMENT_FORMATS.ROUND_ROBIN]: 'Round Robin'
};

export const TOURNAMENT_FORMAT_DESCRIPTIONS = {
  [TOURNAMENT_FORMATS.SINGLE_ELIMINATION]: 'Players are eliminated after one loss',
  [TOURNAMENT_FORMATS.DOUBLE_ELIMINATION]: 'Players are eliminated after two losses',
  [TOURNAMENT_FORMATS.MODIFIED_SINGLE_ELIMINATION]: 'APA format - every player guaranteed at least 2 games',
  [TOURNAMENT_FORMATS.ROUND_ROBIN]: 'Every player plays every other player once (4-8 players)'
};

// Default branding configuration for tournaments
export const DEFAULT_BRANDING = {
  bannerImageUrl: '',
  logoUrl: '',
  primaryColor: '#007bff',
  secondaryColor: '#6c757d',
  accentColor: '#28a745',
  tagline: '',
  socialLinks: {
    facebook: '',
    instagram: '',
    twitter: '',
    website: ''
  },
  sponsors: [],
  // Promotional announcement for bar advertising
  announcement: {
    enabled: false,
    message: '',
    ctaText: '',
    ctaUrl: ''
  },
  // Venue-specific branding
  venue: {
    logoUrl: '',
    hours: '',
    menuUrl: '',
    phone: ''
  },
  // Prize display enhancements
  prizeDisplay: {
    showBreakdown: true,
    customPrizes: [], // { place: 1, description: 'Trophy + $100' }
    addedMoney: 0,
    addedMoneySource: '' // e.g., "House Added" or sponsor name
  },
  // Theme settings
  theme: {
    style: 'default', // 'default', 'dark', 'gradient'
    gradientStart: '#667eea',
    gradientEnd: '#764ba2'
  },
  showSplashScreen: true,
  autoCollapse: true
};

// Helper function to create default branding object
export const createDefaultBranding = () => ({
  ...DEFAULT_BRANDING,
  socialLinks: { ...DEFAULT_BRANDING.socialLinks },
  sponsors: []
});

// Helper function to merge branding with defaults
export const mergeBrandingWithDefaults = (branding) => {
  if (!branding) return createDefaultBranding();

  return {
    ...DEFAULT_BRANDING,
    ...branding,
    socialLinks: {
      ...DEFAULT_BRANDING.socialLinks,
      ...(branding.socialLinks || {})
    },
    sponsors: branding.sponsors || [],
    announcement: {
      ...DEFAULT_BRANDING.announcement,
      ...(branding.announcement || {})
    },
    venue: {
      ...DEFAULT_BRANDING.venue,
      ...(branding.venue || {})
    },
    prizeDisplay: {
      ...DEFAULT_BRANDING.prizeDisplay,
      ...(branding.prizeDisplay || {}),
      customPrizes: branding.prizeDisplay?.customPrizes || []
    },
    theme: {
      ...DEFAULT_BRANDING.theme,
      ...(branding.theme || {})
    }
  };
};

// Default registration configuration for tournaments
export const DEFAULT_REGISTRATION = {
  enabled: false,
  maxCapacity: null, // null = unlimited
  registeredUsers: []
};

// Helper function to create default registration object
export const createDefaultRegistration = () => ({
  ...DEFAULT_REGISTRATION,
  registeredUsers: []
});

// Helper function to merge registration with defaults
export const mergeRegistrationWithDefaults = (registration) => {
  if (!registration) return createDefaultRegistration();

  return {
    ...DEFAULT_REGISTRATION,
    ...registration,
    registeredUsers: registration.registeredUsers || []
  };
};